import _ from "lodash";
import lostVaccines from "../data/vaccineLostDosis";
import { Paciente } from "./types/Paciente";

export default class LostVaccines {

    readonly lostDosis: Array<any> = _.zip(lostVaccines);

    lostVaccinesCovered(paciente: Paciente, vaccinePlan: Array<number>) : any
    {
        let condiciones = paciente.conditions;
        let lostDosisCovered: any = [];

        for(let iVacuna = 0; iVacuna < vaccinePlan.length; iVacuna++){
            lostDosisCovered[iVacuna] = 0;
            for(let iCondicion = 0; iCondicion < condiciones.length; iCondicion++){
                if(condiciones[iCondicion] < 100 && lostVaccines[iCondicion][iVacuna] == 1){
                    lostDosisCovered[iVacuna] = 1;
                }
            }
        }
        return lostDosisCovered;
    }

}